import _ from 'lodash'

import {routeTo} from '@/utils/router'
import {AboutUsStatisticName} from '@/utils/statistics/constants'
import {AboutUsStatisticType} from '@/utils/statistics/types'

import {team, TeamMemberSlug} from './team'

export const getAboutUsContent = () => ({
  metaTitle: 'about-us.meta-title',
  metaDescription: 'about-us.meta-description',
  header: {
    buttonLinkText: 'about-us.button-how-we-work',
    buttonLinkHref: routeTo.howItWorks(),
  },
  hero: {
    title: 'about-us.hero-title',
    subtitle: 'about-us-statistics-description',
    imageSrc: '/images/hero/trama-team.png',
    imageAlt: 'TramaTM team',
  },
  modernServices: {
    title: 'about-us.modern-ls-title',
    imageSrc: '/images/brain.svg',
    imageAlt: 'Half human brain circuit board AI',
    techVision: {
      title: 'about-us.modern-ls-tech-vision-title',
      descriptions: [
        'about-us.modern-ls-tech-vision-desc-0',
        'about-us.modern-ls-tech-vision-desc-1',
      ],
    },
    humanTouch: {
      title: 'about-us.modern-ls-human-touch-title',
      descriptions: [
        'about-us.modern-ls-human-touch-desc-0',
        'about-us.modern-ls-human-touch-desc-1',
      ],
    },
  },
  story: {
    title: 'about-us.story-title',
    timeline: [
      {
        date: 'about-us.story-roadmap-date-0',
        description: 'about-us.story-roadmap-description-0',
      },
      {
        date: 'about-us.story-roadmap-date-1',
        description: 'about-us.story-roadmap-description-1',
      },
      {
        date: 'about-us.story-roadmap-date-2',
        description: 'about-us.story-roadmap-description-2',
      },
      {
        date: 'about-us.story-roadmap-date-3',
        description: 'about-us.story-roadmap-description-3',
      },
      {
        date: 'about-us.story-roadmap-date-4',
        description: 'about-us.story-roadmap-description-4',
      },
      {
        date: 'about-us.story-roadmap-date-5',
        description: 'about-us.story-roadmap-description-5',
      },
      {
        date: 'about-us.story-roadmap-date-6',
        description: 'about-us.story-roadmap-description-6',
      },
    ],
  },
  getStarted: {
    title: 'about-us.get-started-growth-banner-title',
    buttonLinkHref: routeTo.howItWorks(),
    buttonLinkText: 'button-see-how-we-work',
  },
  showMoreText: 'show-more-text',
  profilePage: {
    metaTitle: 'team.about-us-profile-page-meta-title',
    metaDescription: 'team.about-us-profile-page-meta-description',
    aboutTitle: 'team.about-title',
    educationTitle: 'team.education-title',
    licensesTitle: 'team.licenses-title',
    newestArticlesTitle: 'team.newest-articles-by-author-title',
    navigation: {
      title: 'team.team-navigation-title',
      teamMembers: [
        team[TeamMemberSlug.igorDemcak],
        team[TeamMemberSlug.martinaSallay],
        team[TeamMemberSlug.marekKrizka],
        team[TeamMemberSlug.janDohnal],
      ],
      buttonText: 'team.team-navigation-button',
      buttonLinkHref: routeTo.aboutUs.home(),
    },
  },
})

export const getAboutUsStatistics = (
  numOfRegisteredTrademarks?: number | string,
  isShortDescription?: boolean,
): Record<AboutUsStatisticName, AboutUsStatisticType> => ({
  [AboutUsStatisticName.registeredTrademarks]: {
    title: numOfRegisteredTrademarks ?? '',
    description: 'trademarks-registered-title',
    imageSrc: '/images/icons/validity.svg',
    imageAlt: 'Document with a checkmark',
  },
  [AboutUsStatisticName.settledCases]: {
    title: 640,
    description: 'cases-won-title',
    imageSrc: '/images/icons/scales-of-justice.svg',
    imageAlt: 'Scales of justice',
  },
  [AboutUsStatisticName.coveredCountries]: {
    title: '100+',
    description: isShortDescription ? 'countries-covered-title' : 'jurisdictions-covered-title',
    imageSrc: '/images/icons/globe.svg',
    imageAlt: 'Globe',
  },
  [AboutUsStatisticName.monitoredCountries]: {
    title: '190',
    description: 'countries-covered-title',
    imageSrc: '/images/icons/map.svg',
    imageAlt: 'Map',
  },
  [AboutUsStatisticName.teamMembers]: {
    title: _.size(team),
    description: 'team-members-title',
    imageSrc: '/images/icons/avatar.svg',
    imageAlt: 'Avatar',
  },
  [AboutUsStatisticName.overcomeOfficeActions]: {
    title: 498,
    description: 'office-actions-overcome-title',
    imageSrc: '/images/icons/validity.svg',
    imageAlt: 'Document with a checkmark',
  },
  [AboutUsStatisticName.overcomeOppositions]: {
    title: 142,
    description: 'oppositions-overcome-title',
    imageSrc: '/images/icons/validity.svg',
    imageAlt: 'Document with a checkmark',
  },
  [AboutUsStatisticName.monthlyWatchHits]: {
    title: '10 000+',
    description: 'monthly-watch-hits-title',
    imageSrc: '/images/icons/binoculars.svg',
    imageAlt: 'Binoculars',
  },
  [AboutUsStatisticName.brandsMonitored]: {
    title: '2 000+',
    description: 'brands-monitored-title',
    imageSrc: '/images/icons/star.svg',
    imageAlt: 'Star',
  },
})
